import { useContext, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import AllDevices from "./AllDevices";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../components/Loader";

export default function AuvikDevice() {
  const { apiUrl } = useContext(AuthContext);
  const navigate = useNavigate();
  const { tenantId } = useParams();

  const getTenantsLive = async () => {
    try {
      const res = await axios.get(`${apiUrl}auvik/tenants_live`, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      return [];
    }
  };

  const tenantsLive = useQuery({
    queryKey: ["auvik"],
    queryFn: getTenantsLive,
  });

  const isTenantIdValid = Array.isArray(tenantsLive.data)
    ? tenantsLive.data.some((tenant) => tenant.auvik_id === tenantId)
    : false;

  useEffect(() => {
    if (!tenantsLive.isLoading && !isTenantIdValid) {
      navigate("/auvik");
    }
  }, [isTenantIdValid, navigate, tenantsLive.isLoading]);

  if (tenantsLive.isLoading) {
    return <Loader />;
  }

  return isTenantIdValid ? <AllDevices tenantId={tenantId} /> : null;
}
